module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/eRQ2qH/tc-custom/9781423643036.jpg?1737164465190",
      "alt": "This image is the cover for the book 101 Things To Do With Beer, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With Beer, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Recipes that are good for what ales you—part of the million-selling cookbook series!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Take your love of the suds to the next level by infusing your favorite libation into breakfast, lunch, and dinner with"), _c('i', [_vm._v(" 101 Things To Do With Beer.")]), _vm._v(" Home cooks can depend on "), _c('i', [_vm._v("101 Things to Do with Beer")]), _vm._v("'s wide range of creative recipes and affordable price to add some “hop” to every meal."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Give each dish the boost of flavor it deserves: from Beer Battered Apple Fritters to Beer Simmered Chicken Tacos; Garlic Parmesan Onion Rings to Chocolate Stout Ice Cream, you’ll satisfy even the most skeptical guest. Raise your plate and say “Cheers!”"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eliza Cross\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0